import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';

var _a;
var FAQ_NAMESPACE = 'FAQ_NAMESPACE';
var SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
var SET_CATEGORIES = 'SET_CATEGORIES';
var SET_ENTRIES = 'SET_ENTRIES';
var SET_IS_LOADING = 'SET_IS_LOADING';
var SET_CATEGORIES_LANGUAGE = 'SET_CATEGORIES_LANGUAGE';
var SET_ENTRIES_LANGUAGE = 'SET_ENTRIES_LANGUAGE';
var faqGetters = {
    searchText: function (state) {
        return state.searchText;
    },
    categories: function (state) {
        return state.categories;
    },
    entries: function (state) {
        return state.entries;
    },
    isLoading: function (state) {
        return state.isLoading;
    },
};
var faqActions = {
    setSearchText: function (_a, text) {
        var commit = _a.commit;
        commit(SET_SEARCH_TEXT, text);
    },
    fetchCategories: function (_a, lang) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var categories;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (getters.isLoading) {
                            return [2 /*return*/];
                        }
                        if (getters.categories.length && state.categoriesLanguage === lang) {
                            return [2 /*return*/];
                        }
                        commit(SET_IS_LOADING, true);
                        commit(SET_CATEGORIES_LANGUAGE, lang);
                        return [4 /*yield*/, magic.methods.faqsCategories.get(lang)];
                    case 1:
                        categories = _b.sent();
                        commit(SET_CATEGORIES, categories);
                        commit(SET_IS_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
    fetchEntries: function (_a, lang) {
        var commit = _a.commit, getters = _a.getters, state = _a.state;
        return __awaiter(this, void 0, void 0, function () {
            var entries;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (getters.isLoading) {
                            return [2 /*return*/];
                        }
                        if (getters.entries.length && state.entriesLanguage === lang) {
                            return [2 /*return*/];
                        }
                        commit(SET_IS_LOADING, true);
                        commit(SET_ENTRIES_LANGUAGE, lang);
                        return [4 /*yield*/, magic.methods.faqs.get(lang)];
                    case 1:
                        entries = _b.sent();
                        commit(SET_ENTRIES, entries);
                        commit(SET_IS_LOADING, false);
                        return [2 /*return*/];
                }
            });
        });
    },
};
var faq = {
    namespaced: true,
    state: {
        searchText: '',
        categories: [],
        entries: [],
        isLoading: false,
        entriesLanguage: null,
        categoriesLanguage: null,
    },
    getters: faqGetters,
    actions: faqActions,
    mutations: (_a = {},
        _a[SET_SEARCH_TEXT] = function (state, text) {
            state.searchText = text;
        },
        _a[SET_CATEGORIES] = function (state, categories) {
            state.categories = categories;
        },
        _a[SET_ENTRIES] = function (state, entries) {
            state.entries = entries;
        },
        _a[SET_IS_LOADING] = function (state, isLoading) {
            state.isLoading = isLoading;
        },
        _a[SET_CATEGORIES_LANGUAGE] = function (state, language) {
            state.categoriesLanguage = language;
        },
        _a[SET_ENTRIES_LANGUAGE] = function (state, language) {
            state.entriesLanguage = language;
        },
        _a),
};

export { FAQ_NAMESPACE, faq, faqActions, faqGetters };
